export const ROLES_DATA_SUCCESS = 'ROLE_DATA_SUCCESS';
export const GET_ROLES = 'GET_ROLES';
